import { GridEntityCard } from '../../components/catalog/GridEntityCards';
import { TegelNotice } from '../../components/common/Tegel';

export const TechDocsEntityContentEmptyState = () => (
  <div className="tegel-entity-docs-tab">
    <GridEntityCard variant="gridItem" title="Documentation">
      <TegelNotice variant="information" header="No TechDocs configured">
        Add a TechDocs annotation to this entity to make documentation available
        from Driveline.
      </TegelNotice>
    </GridEntityCard>
  </div>
);
